import { Box, Icon, withCitrusTheme } from '@gousto-internal/citrus-react'

export const AddIcon = withCitrusTheme(Icon, (theme) => ({
  color: theme.tokens.colors.White,
}))

export const AddIconTile = withCitrusTheme(Box, (theme) => ({
  display: 'flex',
  borderRadius: '3px',
  alignItems: 'center',
  padding: '8px',
  backgroundColor: theme.tokens.colors.Secondary_400,
  '&:hover': {
    backgroundColor: theme.tokens.colors.Secondary_600,
  },
}))
